(function ($) {

    $(document).ready(function () {
        if ($('.elementor-field-group-field_cdde2e2').length > 0) {
            $('.elementor-field-group-field_cdde2e2 label').append('<span class="show-tooltip">?</span>');
            $('<div class="tooltip-content"><div><p class="head">Opcja podstawowa</p><p class="desc">Klient sam pakuje drobne rzeczy (np. ubrania, szkło, książki). Na życzenie za dodatkową opłaą dostarczamy kartony. My zajmujemy się zabezpieczeniem mebli, wyniesieniem, transportem i wniesieniem na miejscu.</p></div><div><p class="head">Opcja kompleksowa</p><p class="desc">Zajmujemy się wszystkim – pakowaniem, zabezpieczeniem, transportem i rozpakowaniem. Klient nie musi robić nic. Przeprowadzka bez stresu i wysiłku.</p></div></div>').insertAfter('.show-tooltip');
        }
    })

    if ($('#form-bkt').length > 0) {
        if (!$('#form-bkt').is(':visible')) {
            $(window).on('scroll', function () {
                $('#form-bkt').show();
            })
        }
    }
    if ($('#top-home-element').length > 0) {
        $(window).on('scroll', function () {
            $('#top-home-element').removeAttr('id');
            $('.mobile-start-hide').show();
        })
    }

})(jQuery)